export default {
    'add-holiday': 'إضافة عطلة',
    headers: {
        'duration-in-days': 'المدة بالأيام',
        'start-date': 'تاريخ البدء',
        'reason': 'السبب',
        'for-all-employee': 'لكل الموظفين',
        'job-description': 'المسمى الوظيفي',
        'employees': 'الموظفين'
    },
    inputs: {
        'duration-in-days': 'المدة بالأيام',
        'reason': 'السبب',
        'all-employees': 'لكل الموظفين',
        'job-descriptions': 'المسمى الوظيفي'
    },
    'delete-message-holiday': 'هل أنت متأكد أنك تريد حذف هذه العطلة ؟'
}